import { Button, Col, Input, Row, Select } from 'antd';
import { useCallback, useEffect } from 'react';
import { StyledChargesFiltersForm, StyledFiltersFormItem } from './styles';
import { CustomDrawer } from 'components/CustomDrawer';
import { LuSearch } from 'react-icons/lu';
import { serializeOnlyNumbers } from 'helpers/serializers';
import dayjs from 'dayjs';
import { AllChargeFilters, WalletChargeStatus } from 'types/Wallet';
import { DatePicker } from 'components/DatePicker';
import { AccountsService } from 'modules/escrow/services';
import { AccountStatus } from 'types/Account';
import { useQuery } from '@tanstack/react-query';
import { WalletChargeStatusDescription } from 'constants/wallet';
import { ChargesFiltersType } from '../Charges/types';

interface IChargesFiltersProps {
	isOpen: boolean;
	filters?: AllChargeFilters;
	onClose: () => void;
	onApply: (filters: AllChargeFilters) => void;
}
const ChargesFilters = ({
	isOpen,
	filters,
	onApply,
	onClose,
}: IChargesFiltersProps) => {
	const [form] = StyledChargesFiltersForm.useForm();

	const { data: accountsList, isLoading: isAccountsLoading } = useQuery({
		queryKey: ['accountsList'],
		queryFn: () =>
			AccountsService.getAccounts({
				size: 100,
				status: AccountStatus.ACTIVE,
			}),
		enabled: isOpen,
	});

	const onFinish = useCallback(
		(values: ChargesFiltersType) => {
			onApply({
				...values,
				status:
					values.status && values.status.length > 0
						? values.status
						: undefined,
				taxpayer_id:
					values.taxpayer_id && values.taxpayer_id.length > 0
						? serializeOnlyNumbers(values.taxpayer_id)
						: undefined,
				charge_code:
					values.charge_code && values?.charge_code != null
						? values?.charge_code
						: undefined,
				wallet_code:
					values.wallet_code && values?.wallet_code != null
						? values?.wallet_code
						: undefined,
				bar_code: values.bar_code ?? undefined,
				beneficiary_account:
					values.beneficiary_account &&
					values.beneficiary_account.length > 0
						? values.beneficiary_account
						: undefined,
				debtor_name:
					values.debtor_name && values.debtor_name.length > 0
						? values.debtor_name
						: undefined,
				max_created_at: values.max_created_at
					? values.max_created_at.toISOString()
					: undefined,
				min_created_at: values.min_created_at
					? values.min_created_at.toISOString()
					: undefined,
				max_due_date: values.max_due_date
					? values.max_due_date.toISOString()
					: undefined,
				min_due_date: values.min_due_date
					? values.min_due_date.toISOString()
					: undefined,
			});
		},
		[onApply],
	);

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				// taxpayer_id:
				// 	filters?.taxpayer_id &&
				// 	normalizeCpfCnpj(filters?.taxpayer_id),
				debtor_name: filters?.debtor_name,
				charge_code: filters?.charge_code,
				wallet_code: filters?.wallet_code ?? undefined,
				bar_code: filters?.bar_code ?? undefined,
				beneficiary_account: filters?.beneficiary_account,
				max_created_at: filters?.max_created_at
					? dayjs(filters.max_created_at)
					: undefined,
				min_created_at: filters?.min_created_at
					? dayjs(filters.min_created_at)
					: undefined,
				status: filters?.status,
				// max_due_date: filters?.max_due_date
				// 	? dayjs(filters.max_due_date)
				// 	: undefined,
				// min_due_date: filters?.min_due_date
				// 	? dayjs(filters.min_due_date)
				// 	: undefined,
			});
		}
	}, [isOpen, form, filters]);

	return (
		<CustomDrawer
			onClose={onClose}
			open={isOpen}
			title="Busca avançada"
			footer={
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<Button
							style={{
								display: 'flex',
								alignItems: 'center',
								width: '100%',
								justifyContent: 'center',
								position: 'relative',
							}}
							size="large"
							type="primary"
							onClick={form.submit}
						>
							Aplicar filtros
							<LuSearch
								size={21}
								style={{ position: 'absolute', right: '15px' }}
							/>
						</Button>
					</Col>
				</Row>
			}
		>
			<StyledChargesFiltersForm
				initialValues={{
					// taxpayer_id:
					// 	filters?.taxpayer_id &&
					// 	normalizeCpfCnpj(filters?.taxpayer_id),
					debtor_name: filters?.debtor_name,
					id: filters?.id,
					wallet_code: filters?.wallet_code ?? undefined,
					charge_code: filters?.charge_code,
					bar_code: filters?.bar_code ?? undefined,
					beneficiary_account:
						filters?.beneficiary_account ?? undefined,
					max_created_at: filters?.max_created_at
						? dayjs(filters.max_created_at)
						: undefined,
					min_created_at: filters?.min_created_at
						? dayjs(filters.min_created_at)
						: undefined,
					status: filters?.status,
					// max_due_date: filters?.max_due_date
					// 	? dayjs(filters.max_due_date)
					// 	: undefined,
					// min_due_date: filters?.min_due_date
					// 	? dayjs(filters.min_due_date)
					// 	: undefined,
				}}
				layout="vertical"
				form={form}
				onFinish={onFinish}
			>
				{/* <Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<FiltersFormItem
							name="taxpayer_id"
							label="CPF / CNPJ"
							normalize={value => normalizeCpfCnpj(value)}
							rules={[cpfCnpjRule]}
						>
							<Input placeholder="Digite aqui" />
						</FiltersFormItem>
					</Col>
				</Row> */}
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<StyledFiltersFormItem name="status" label="Status">
							<Select
								mode="multiple"
								style={{ minWidth: '10rem' }}
								placeholder="Selecionar"
								allowClear={true}
								options={Object.keys(
									WalletChargeStatusDescription,
								).map(key => ({
									label: WalletChargeStatusDescription[
										key as WalletChargeStatus
									],
									value: key,
								}))}
							/>
						</StyledFiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<StyledFiltersFormItem
							name="debtor_name"
							label="Nome do sacado"
						>
							<Input placeholder="Digite aqui" />
						</StyledFiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<StyledFiltersFormItem
							name="beneficiary_account"
							label="Conta de destino"
						>
							<Select
								style={{ minWidth: '10rem' }}
								placeholder="Selecionar"
								loading={isAccountsLoading}
								allowClear={true}
								options={accountsList?.content?.map(
									account => ({
										label: account.person.name,
										value: account.account,
									}),
								)}
							/>
						</StyledFiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<StyledFiltersFormItem
							label="Cód. do boleto"
							name="charge_code"
						>
							<Input placeholder="Digite aqui" />
						</StyledFiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<StyledFiltersFormItem
							label="Cód. da carteira"
							name="wallet_code"
						>
							<Input placeholder="Digite aqui" />
						</StyledFiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<StyledFiltersFormItem
							label="Cód. de barras"
							name="bar_code"
						>
							<Input placeholder="Digite aqui" />
						</StyledFiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[8, 8]} style={{ width: '100%' }} align="middle">
					<Col span={12}>
						<StyledFiltersFormItem
							name="min_created_at"
							label="Data de Criação"
						>
							<DatePicker placeholder="dd/mm/aaaa" />
						</StyledFiltersFormItem>
					</Col>
					<Col span={12}>
						<StyledFiltersFormItem name="max_created_at" label=" ">
							<DatePicker placeholder="dd/mm/aaaa" />
						</StyledFiltersFormItem>
					</Col>
				</Row>
				{/* NÃO VAI TER NA VERSÃO ATUAL*/}
				{/* <Row gutter={[8, 8]} style={{ width: '100%' }} align="middle">
					<Col span={12}>
						<FiltersFormItem
							name="min_due_date"
							label="Data de Vencimento"
						>
							<DatePicker placeholder="dd/mm/aaaa" />
						</FiltersFormItem>
					</Col>
					<Col span={12}>
						<FiltersFormItem name="max_due_date" label=" ">
							<DatePicker placeholder="dd/mm/aaaa" />
						</FiltersFormItem>
					</Col>
				</Row> */}
			</StyledChargesFiltersForm>
		</CustomDrawer>
	);
};

export default ChargesFilters;
